import { render, staticRenderFns } from "./SmallDetailsSingleLogoModal.vue?vue&type=template&id=01d80960&scoped=true"
import script from "./SmallDetailsSingleLogoModal.vue?vue&type=script&lang=ts"
export * from "./SmallDetailsSingleLogoModal.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./SmallDetailsSingleLogoModal.vue?vue&type=style&index=0&id=01d80960&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./SmallDetailsSingleLogoModal.vue?vue&type=style&index=1&id=01d80960&prod&lang=css")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "01d80960",
  null
  ,true
)

export default component.exports